import React, { useState } from 'react'

import {
  legendStyles,
  containerStyles,
  inputStyles,
  labelStyles,
  titleStyles,
  subtitleStyles,
} from './styles'
import { RadioProps } from './Radio.types'

export const Radio = ({
  className = '',
  radioClass = '',
  labelClass = '',
  startAt,
  name,
  title,
  onChange,
  testId,
  radios = [],
}: RadioProps) => {
  const [value, setValue] = useState(radios.find(r => r.checked)?.value || '')

  // Allow callers to offset the generated index used in ids to avoid
  // collisions when multiple Radio components are rendered in a list.
  const startIndex = typeof startAt === 'number' ? startAt : 0

  const handleChange = (newValue: string) => {
    setValue(newValue)
    onChange?.(newValue)
  }

  return (
    // wrap radios in a fieldset so a legend can describe the group of radios
    <fieldset
      className={`${className} border-0 p-0 mb-8 last:mb-0`}
      data-testid={testId}
    >
      {/* Legend describes what all the radios are for */}
      {!!title && (
        <legend className={legendStyles} id={`${name}-title`}>
          {title}
        </legend>
      )}

      {/* List of radios */}
      {radios.map((radio, i) => {
        const idx = startIndex + i
        return (
          <div key={i} className={`${radioClass} ${containerStyles}`}>
            <input
              type="radio"
              role="radio"
              name={name}
              id={`${name}-${idx}`}
              value={radio.value}
              defaultChecked={radio.checked}
              className={inputStyles}
              disabled={radio.disabled}
              onChange={() => handleChange(radio.value)}
              aria-disabled={radio.disabled}
              aria-labelledby={`${name}-${idx}-label`}
              aria-describedby={`${name}-${idx}-description`}
              aria-invalid="false"
            />
            <label
              className={`${labelClass} ${labelStyles}`}
              htmlFor={`${name}-${idx}`}
              id={`${name}-${idx}-label`}
            >
              <span className={titleStyles}>{radio.label}</span>
              {!!radio.subtitle && (
                <span
                  className={subtitleStyles}
                  id={`${name}-${idx}-description`}
                >
                  {radio.subtitle}
                </span>
              )}
            </label>
          </div>
        )
      })}
    </fieldset>
  )
}
